module.exports = __webpack_public_path__ + "static/media/siemens_logo.2b486bc2.png";